<template>
  <section class="section container pt-0">
    <div class="title is-3">{{ $t("welcome") }} {{ member.name }}</div>
    <div class="subtitle is-4">
      {{ $t("hours remaining") }}
      <span class="has-text-primary">{{ member.remaining_hours }}</span>
    </div>

    <article class="message is-info">
      <div class="message-body" v-html="$t('_booking_instructions_')"></div>
    </article>

    <full-calendar
      :options="calendarOptions"
      ref="full_calendar"
    ></full-calendar>
    <booking-modal
      ref="booking_modal"
      @booking_made="refresh"
      @booking_canceled="refresh"
    />
  </section>
</template>

<script>
import {
  put,
  error_message,
  get,
  api_host,
  warning_message,
  post,
  error_alert,
  generate_error_message_text,
} from "@/utils";
import BookingModal from "./booking_modal/Index.vue";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import { v4 } from "uuid";

export default {
  name: "ReservationIndex",
  components: { BookingModal, FullCalendar },
  data() {
    let v = this;
    return {
      member: {},
      stations: [],
      availability: [],
      calendarOptions: {
        displayEventTime: false,
        customButtons: {
          refresh: {
            text: v.$t("refresh"),
            click: function () {
              v.refresh();
            },
          },
        },
        eventSources: [
          // {
          //   url: `${api_host}/pilates_member/reservation/booking`,
          //   method: "GET",
          //   extraParams: {
          //     uuid: v.$route.params.uuid,
          //   },
          //   failure: function (err) {
          //     console.error(err);
          //     error_message(err);
          //   },
          //   success: function (content, xhr) {
          //     console.log("Events fetched successfully!", content);
          //     return content.map((e) => {
          //       e.color = moment(e.start).isBefore(moment()) ? "gray" : "";
          //       return e;
          //     });
          //   },
          // },
          {
            events: function (info, successCallback, failureCallback) {
              let member_uuid = v.$route.params.uuid;
              get("/pilates_member/reservation/classes", {
                start: info.startStr,
                end: info.endStr,
                uuid: member_uuid,
              })
                .then((r) => {
                  let recurring_events = r.map((e) => {
                    let daysOfWeek = moment(e.start_date).isoWeekday();

                    // console.log("daysOfWeek", daysOfWeek);
                    // if (daysOfWeek == 7) daysOfWeek = 0;

                    // let color = "#C34D4D";
                    let color = "#537188";
                    if (
                      e.booking_count &&
                      e.booking_count >= e.maximum_capacity
                    )
                      color = "#D37676";

                    if (e.is_current_user_booked) color = "#677D6A";

                    return {
                      title: `${v.$t("coach")}: ${e.coach} - ${
                        e.booking_count
                      }/${e.maximum_capacity} ${v.$t("assistants")}`,
                      daysOfWeek: [daysOfWeek],
                      startTime: moment(e.start_date).format("HH:mm"),
                      // endTime: moment(e.end_date).format("HH:mm"),
                      endTime: moment(e.start_date)
                        .add(1, "hour")
                        .format("HH:mm"),
                      id: e.uuid,
                      color: color,
                      // display: "background",
                    };
                  });
                  successCallback(recurring_events);
                })
                .catch((error) => {
                  error_message(error);
                  failureCallback(error);
                });
            },
          },
        ],
        // events: {
        //   url: `${api_host}/pilates_member/reservation/booking`, // use the `url` property
        //   method: "POST",
        // },

        // any other sources...

        allDaySlot: false,
        locale: v.$i18n.locale,
        // editable: true,
        nowIndicator: true,
        // now: true,
        buttonText: {
          today: v.$t("today"),
          month: v.$t("month"),
          week: v.$t("week"),
          day: v.$t("day"),
        },
        // footerToolbar: {
        //   left: "prev,next today",
        //   center: "title",
        //   right: "dayGridMonth,timeGridWeek,timeGridDay",
        // },
        headerToolbar: {
          left: "prev,next today refresh",
          center: "title",
          right: "timeGridWeek",
        },
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: "timeGridWeek",
        eventClick: function (info) {
          let start_date = moment(info.event._instance.range.start).add(
            6,
            "hour"
          );
          if (start_date.isBefore(moment())) {
            warning_message(
              v.$t("you cannot book for past classes, select future classes")
            );
            return false;
          }

          let booking_making_time_limit = Number(
            v.module_settings.booking_making_time_limit || 0
          );
          let minimum_booking_time = moment().add(
            booking_making_time_limit,
            "minutes"
          );
          console.log(
            "minimum_booking_time",
            minimum_booking_time.format("YYYY-MM-DD HH:mm")
          );
          if (!minimum_booking_time.isBefore(start_date)) {
            warning_message(
              `${v.$t(
                "cannot book for this class, minimum booking time limit is"
              )} ${booking_making_time_limit} ${v.$t("minutes")}`
            );
            return false;
          }

          // console.log("eventClick", info.event._instance.range.start);
          // if (info.event._def.publicId) console.log("eventClick", info);
          v.$refs.booking_modal.show_modal(
            info.event._def.publicId,
            info.event._instance.range.start
          );
        },
        dateClick: function (info) {
          // v.$refs.booking_modal.show_modal(info);
          // console.log("dateClick", v.$refs);
          // v.calendarOptions.events.push({
          //   id: v4(),
          //   start: info.dateStr,
          //   end: moment(info.dateStr).add(1, "hour").format(),
          // });
        },
        eventChange: function (info) {
          return false;
          // console.log("eventChange", info.event._def.publicId);
          // let event = v.calendarOptions.events.find(
          //   (e) => e.id === info.event._def.publicId
          // );
          // event.start = info.event.start;
          // event.end = info.event.end;
        },
        // events: [],
      },
      module_settings: {},
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    make_reservation() {
      let v = this;
      v.$refs.reserve_modal.show_modal(v.availability);
    },
    refresh() {
      let v = this;
      v.$refs.full_calendar.getApi().refetchEvents();
    },
  },
  mounted() {
    let v = this;
    let member_uuid = v.$route.params.uuid;
    get("/pilates_member/reservation/member", { uuid: member_uuid })
      .then((member) => {
        v.member = member;
      })
      .catch((error) => {
        error_message(error);
      });

    get("/pilates_member/reservation/settings", { uuid: member_uuid })
      .then((settings) => {
        v.module_settings = settings;
      })
      .catch((error) => {
        error_message(error);
      });
  },
  created() {
    // let v = this;
    // let member_uuid = v.$route.params.uuid;
    // get("/pilates_member/reservation/stations", { uuid: member_uuid })
    //   .then((r) => {
    //     v.stations = r.stations;
    //     v.availability = r.availability;
    //     let evnts = r.availability.map((e) => {
    //       let day_of_week = e.iso_day_of_week;
    //       if (day_of_week == "7") day_of_week = "0";
    //       return {
    //         daysOfWeek: [day_of_week],
    //         startTime: e.from,
    //         endTime: e.to,
    //         display: "background",
    //       };
    //     });
    //     v.calendarOptions.events = evnts;
    //   })
    //   .catch((error) => {
    //     error_message(error);
    //   });
  },
};
</script>

<style scoped></style>
